import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-l1-leo-kids-desk",
  "use": "icon-soc-l1-leo-kids-desk-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-l1-leo-kids-desk\">\r\n  <path fill=\"currentColor\" d=\"M160 192h704v448H160V192zm64 64v320h576V256H224z\" />\r\n  <path fill=\"currentColor\" d=\"M288 320h160v48H288V320zm0 96h288v48H288V416zm0 96h224v48H288V512z\" />\r\n  <path fill=\"currentColor\" d=\"M320 704h384v64H320zm-96 96h576v48H224z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-l1-leo-kids-desk.svg
// module id = QOtd
// module chunks = 546